import { useLocale } from '@/lib/i18n';

export function FaqArticle({ faq }: { faq: { question: string; answer: string }[] }) {
  const { t } = useLocale();
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-10">
      <p className="text-xs font-bold uppercase tracking-widest text-[var(--color-primary)]">{t('page.kicker')}</p>
      <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-950">{t('foot.faq')}</h1>
      {faq.length === 0 ? (
        <p className="mt-6 text-sm text-slate-500">{t('page.faqEmpty')}</p>
      ) : (
        <dl className="mt-6 space-y-3">
          {faq.map((item) => (
            <div key={item.question} className="rounded-2xl border border-slate-200 bg-white p-4">
              <dt className="font-bold text-slate-950">{item.question}</dt>
              <dd className="mt-1 text-sm leading-6 text-slate-600">{item.answer}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
}

export function CopyArticle({ kind, body }: { kind: 'privacy' | 'terms'; body: string }) {
  const { t } = useLocale();
  const title = kind === 'privacy' ? t('foot.privacy') : t('foot.terms');
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-10">
      <p className="text-xs font-bold uppercase tracking-widest text-[var(--color-primary)]">{t('page.kicker')}</p>
      <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-950">{title}</h1>
      <p className="mt-6 whitespace-pre-wrap text-sm leading-7 text-slate-700">
        {body.trim() || t('page.copyEmpty')}
      </p>
    </section>
  );
}

export function VehiclePageStatus({ kind }: { kind: 'loading' | 'missing' }) {
  const { t } = useLocale();
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-16 text-center">
      <h1 className="text-2xl font-black text-slate-950">
        {kind === 'loading' ? t('page.loading') : t('page.missingCar')}
      </h1>
      {kind === 'missing' ? (
        <a href="/vehicles" className="mt-4 inline-block text-sm font-bold text-[var(--color-primary)]">
          {t('page.backToFleet')}
        </a>
      ) : null}
    </section>
  );
}
